(function() {
  "use strict";
  angular.module("marketPlace.listings", []);
})();
